import React, { useContext, useEffect, useState } from "react";
import FilterAltIcon from '@mui/icons-material/FilterAlt';

import axios from "axios";
import { baseServiceUrl, urls } from "../../environment";
import toast from "react-hot-toast";
import { Box, Tabs, Tab, Typography, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import CheckIcon from "@mui/icons-material/Check";
import GeneralKATable from "../../components/GeneralKATable";
import { DataType } from "ka-table";
import { KATableHeaderTypes } from "../../components/GeneralKATable/GeneralKATable.interface";

import FitlerSidebar from "../../components/FitlerSidebar";
import AddIcon from "@mui/icons-material/Add";
import useUserStore from "../../stores/useUserStores";
import useQuestionStores from "../../stores/useQuestionStores";
const QuestionList = () => {
  const { token, setLoading } = useUserStore();
  const questionContext = useQuestionStores();

  const [Subjectlist, setSubjectList] = useState<any[]>([]);
  const [question, setQuestion] = useState<any[]>([]);
  const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false);
  const [tab, setTab] = useState<any>(0);
  const errornotify = (msg: any) => toast.error(msg);
  const navigate = useNavigate();
  const columns: GridColDef[] = [
    {
      field: "question",
      headerName: "Question",
      width: 350,
    },
    {
      field: "marks",
      headerName: "Marks",
      type: "number",
      width: 200,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "negetive_mark",
      headerName: "Negetive Mark",
      type: "number",
      width: 200,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "options",
      headerName: "Options",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      flex: 1,
      cellClassName: "py-2",
      renderCell: ({ value }: any) => {
        return (
          <div className="flex h-full flex-row justify-left items-center flex-wrap">
            {value.map((m: any) => (
              <div
                className={`mx-1 rounded-2xl h-[30px] px-2 pt-1 flex-row m-1 flex border-[2px]  ${
                  m.iscorrect ? "border-[#559658]" : "border-gray-300"
                } ${m.iscorrect ? "bg-[#C0D8C1]" : "bg-[#E5E7EB]"}`}
              >
                {m.iscorrect && (
                  <CheckIcon
                    style={{ fontSize: 20 }}
                    className="text-[#559658]"
                  />
                )}
                <Typography
                  style={{ fontSize: 12 }}
                  className={`text-xs ${
                    m.iscorrect ? "text-[#559658]" : "text-gray-800"
                  }`}
                >
                  {m.val}
                </Typography>
              </div>
            ))}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    try {
      setLoading(true);
      (async () => {
        const response = await axios.get(baseServiceUrl + urls.getSubjectUrl, {
          headers: {
            Authorization: "Bearer " + token,
          },
        });
        setLoading(false);
        if (response.data) {
          setSubjectList(response.data);
        }
      })();
    } catch (err: any) {
      setLoading(false);
      errornotify(
        err?.response?.data?.message || "Error encounter. Please try again."
      );
    }
  }, []);
  useEffect(() => {
    if (Subjectlist.length > 0) {
      (async () => {
        try {
          setLoading(true);
          const targetSubject = Subjectlist[tab];
          const response = await axios.get(
            baseServiceUrl + urls.getQuestionUrl + targetSubject.domain_key,
            {
              headers: {
                Authorization: "Bearer " + token,
              },
            }
          );
          if (response.data) {
            setQuestion(
              response?.data?.map((item: any, index: any) => ({
                question: item.ques.question,
                marks: item?.ques?.marks,
                negetive_mark: item.ques.negetive_mark,
                options: item.ans.map((o: any, i: number) => ({
                  val: o.options_value + " " + o.anwser_field,
                  iscorrect: o.correct_flag,
                })),
                extra: item,
                id: index,
              }))
            );
          }

          setLoading(false);
        } catch (err: any) {
          setLoading(false);
          errornotify(
            err?.response?.data?.message || "Error encounter. Please try again."
          );
        }
      })();
    }
  }, [tab, Subjectlist]);
  const addNew = () => {
    navigate("/admin-dashboard/create-question");
  };
  const CloseModal = () => {
    setIsFilterOpen(false);
  };

  // const ColumnData: KATableHeaderTypes[] = [
  //   {
  //     key: "grn",
  //     title: "GRN NO",
  //     width: 200,
  //     dataType: DataType.String
  //     // style?:CSSProperties
  //   },
  //   {
  //     key: "period_from",
  //     title: "PERIOD FROM",
  //     width: 150,
  //     dataType: DataType.Date
  //     // style?:CSSProperties
  //   },
  //   {
  //     key: "period_to",
  //     title: "PERIOD TO",
  //     width: 150,
  //     dataType: DataType.Date
  //     // style?:CSSProperties
  //   },
  //   {
  //     key: "txn_time",
  //     title: "PAYMENT DATE",
  //     width: 150,
  //     dataType: DataType.Date
  //     // style?:CSSProperties
  //   },
  //   {
  //     key: "amount",
  //     title: "AMOUNT",
  //     width: 150,
  //     dataType: DataType.String,
  //     style: {
  //       fontWeight: "bold"
  //     }
  //     // style?:CSSProperties
  //   },
  //   {
  //     key: "options",
  //     title: "Options",
  //     width: 300,
  //     dataType: DataType.Object
  //     // style?:CSSProperties
  //   },
  //   {
  //     key: "status",
  //     title: "STATUS",
  //     width: 100,
  //     dataType: DataType.String
  //     // style?:CSSProperties
  //   }
  // ];

  return (
    <section
      id="sample-paper"
      className={` flex flex-col items-center justify-center`}
    >
      {isFilterOpen && (
        <FitlerSidebar
          CloseModal={CloseModal}
          isFilterOpen={isFilterOpen}
          handleResetFilter={() => {}}
          handleApplyFilter={() => {}}
        >
          <div className="w-full mt-5 ">
            <p className="text-lg font-semibold text-slate-800 lg:pl-3 ">
              Filter subject wise
            </p>
            <Grid
              container
              width="100%"
              sx={{ mt: 2, mr: 2, ml: 4 }}
              columnGap={3}
              rowGap={1}
            >
              <Grid
                item
                xs={3}
                sx={{ p: 2 }}
                className="shadow-md flex items-center justify-center"
              >
                Bengali
              </Grid>
              <Grid
                item
                xs={3}
                sx={{ p: 2 }}
                className="shadow-md flex items-center justify-center"
              >
                English
              </Grid>
              <Grid
                item
                xs={3}
                sx={{ p: 2 }}
                className="shadow-md flex items-center justify-center"
              >
                History
              </Grid>
              <Grid
                item
                xs={3}
                sx={{ p: 2 }}
                className="shadow-md flex items-center justify-center"
              >
                Chemsitry
              </Grid>
              <Grid
                item
                xs={3}
                sx={{ p: 2 }}
                className="shadow-md flex items-center justify-center"
              >
                Mathamatics
              </Grid>
              <Grid
                item
                xs={3}
                sx={{ p: 2 }}
                className="shadow-md flex items-center justify-center"
              >
                Physics
              </Grid>
            </Grid>
          </div>
          <div className="w-full mt-8">
            <p className="text-lg font-semibold text-slate-800 lg:pl-3 ">
              Filter complexity wise
            </p>
            <Grid
              container
              width="100%"
              sx={{ mt: 2, mr: 2, ml: 4 }}
              columnGap={3}
              rowGap={1}
            >
              <Grid
                item
                xs={3}
                sx={{ p: 2 }}
                className="shadow-md flex items-center justify-center"
              >
                Hard
              </Grid>
              <Grid
                item
                xs={3}
                sx={{ p: 2 }}
                className="shadow-md flex items-center justify-center"
              >
                Medium
              </Grid>
              <Grid
                item
                xs={3}
                sx={{ p: 2 }}
                className="shadow-md flex items-center justify-center"
              >
                Easy
              </Grid>
            </Grid>
          </div>
        </FitlerSidebar>
      )}
      <div className="container w-full py-4 lg:w-[90%] md:w-[100%] mx-auto">
        {/* <div className="my-5">
          <GeneralKATable
            tableColumns={ColumnData}
            tableData={[
              {
                grn: "34903",
                period_from: new Date("12-03-2023"),
                period_to: new Date("12-04-2023"),
                txn_time: new Date("1-05-2023"),
                amount: 890,
                options:[
                  {
                    name:"Apple",
                    isCorrect:true
                  },
                  {
                    name:"Banana",
                    isCorrect:false
                  },
                  {
                    name:"Guava",
                    isCorrect:false
                  },
                ],
                status: "active"
              },
              {
                grn: "34903",
                period_from: new Date("10-01-2023"),
                period_to: new Date("1-4-2023"),
                txn_time: new Date("01-05-2023"),
                amount: 80,
                options:[
                  {
                    name:"Apple",
                    isCorrect:true
                  },
                  {
                    name:"Banana",
                    isCorrect:false
                  },
                  {
                    name:"Guava",
                    isCorrect:false
                  },
                ],
                status: "active"
              }
            ]}
          />
        </div> */}
        <div className="bg-white rounded shadow-lg p-4 px-4 md:p-8 flex flex-col">
          <div className="flex flex-row items-center justify-between">
            <p className="text-2xl font-semibold mb-5">Question Bank</p>
            <div className="flex gap-x-2">
              <button
                type="button"
                onClick={() => setIsFilterOpen(true)}
                className={`w-[150px] bg-[#2d69eb] hover:bg-[#2563EB] text-white font-medium rounded-lg text-sm px-4 py-2 mt-[10px] text-center flex items-center gap-x-2 justify-center`}
              >
                <FilterAltIcon />
                <p>Filter</p>
              </button>
              <button
                type="button"
                onClick={addNew}
                className={`w-[150px] bg-[#2d69eb] hover:bg-[#2563EB] text-white font-medium rounded-lg text-sm px-4 py-2 mt-[10px] text-center flex items-center gap-x-2 justify-center`}
              >
                <AddIcon />
                Add New
              </button>
            </div>
          </div>

          <div className="mb-3">
            <Box
              className="border-b-2"
              sx={{
                bgcolor: "background.paper",
              }}
            >
              <Tabs
                value={tab}
                onChange={(event: any, newValue: any) => setTab(newValue)}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
              >
                {questionContext?.QBankListing?.map(
                  (item: any, index: number) => (
                    <Tab label={item.title} key={index} value={item.id} />
                  )
                )}
              </Tabs>
            </Box>
          </div>
        </div>
        <div className="mb-6">
          <DataGrid
            sx={{
              ".MuiDataGrid-columnHeader": {
                backgroundColor: "#E5E7EB",
              },
              ".MuiDataGrid-columnHeaderTitle": {
                fontWeight: "500",
                fontSize: 16,
                color: "#23304a",
              },
              ".MuiDataGrid-cell": {
                padding: 1,
              },
            }}
            getRowHeight={() => "auto"}
            rows={question}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 5 },
              },
            }}
            pageSizeOptions={[5, 10]}
          />
        </div>
      </div>
    </section>
  );
};

export default QuestionList;
